module.exports = __webpack_public_path__ + "img/logo_white.ecbc7536.png";